import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  Autoplay,
  Thumbs,
  EffectFade,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
Swiper.use([Navigation, Pagination, Autoplay, Thumbs, EffectFade]);

let swiperInstances = {};

jQuery(document).ready(function () {
  if (jQuery(".carousel-activities").length) {
    initActivitiesCarousel();
  }

    if (jQuery(".carousel-activity-content").length) {
    initActivityContentCarousel();
  }

  if (jQuery(".carousel-outfitter-pictures").length) {
    initOutfitterPicturesCarousel();
  }

    if (jQuery(".carousel-activities-pictures").length) {
    initActivitiesPicturesCarousel();
  }

  if (jQuery(".carousel-testimonies").length) {
    initTestimoniesCarousel();
  }

  if (jQuery(".listing-outfitters").length) {
    initListingOutfittersSwiper();
  }

    if (jQuery(".listing-packages").length) {
    initListingPackagesSwiper();
  }

    if (jQuery(".listing-activities").length) {
    initListingActivitiesSwiper();
  }

      if (jQuery(".filters-carousel").length) {
    initFiltersSwiper();
  }

  /**
   * Listen for external slide navigation event
   */
  jQuery(document).on("goToOutfitterSlide", function (event, slideIndex) {
    if (swiperInstances.listingOutfitters) {
      swiperInstances.listingOutfitters.slideTo(slideIndex);
    }
  });
});

/**
 * Initialize the activities carousel swiper
 * Display 3 activities boxes per view
 */
function initActivitiesCarousel() {
  let $activitiesCarousel = jQuery(".carousel-activities");

  let swiperActivities = new Swiper(".carousel-activities", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: ".side-nav-arrows .carousel-next-btn",
      prevEl: ".side-nav-arrows .carousel-prev-btn",
    },
  });
}

/**
 * Initialize the activity content carousel swiper
 * Conditionally enable slider based on number of items and screen size
 */
function initActivityContentCarousel() {
  jQuery(".carousel-activity-content").each(function(index) {
    let $carousel = jQuery(this);
    let $container = $carousel.closest('[data-items-count]');

     if (!$container.length) {
      console.log('No container found for carousel', index);
      return;
    }

  let itemsCount = parseInt($container.data('items-count'));
  let isMobile = window.innerWidth < 1024;
  let $arrows = $container.find('.side-nav-arrows');
  
  // Determine if slider should be active
  let shouldUseSlider = (isMobile && itemsCount >= 2) || (!isMobile && itemsCount >= 3);
  
  if (!shouldUseSlider) {
    $arrows.hide();
  }else{
  $arrows.show();
  }
  
  swiperInstances['activityContent_' + index] = new Swiper($carousel[0], {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: shouldUseSlider && itemsCount > 1,
      enabled: shouldUseSlider,
      allowTouchMove: shouldUseSlider,
      autoHeight: true,
      breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
      navigation: {
        nextEl: $container.find(".carousel-next-btn")[0],
        prevEl: $container.find(".carousel-prev-btn")[0],
      },
    });
  });
}

/**
 * Initialize the outfitters carousel swiper
 * Display 1 outfitter box per view
 */
function initOutfitterPicturesCarousel() {
  let $outfitterPicturesCarousel = jQuery(".carousel-outfitter-pictures");

  let swiperOutfitterPictures = new Swiper(".carousel-outfitter-pictures", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

/**
 * Initialize the activities pictures carousel swiper
 * Display 1 activity box per view
 */
function initActivitiesPicturesCarousel() {
  let $activitiesPicturesCarousel = jQuery(".carousel-activities-pictures");

  let swiperActivitiesPictures = new Swiper(".carousel-activities-pictures", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}


/**
 * Initialize the testimonies carousel swiper
 * Display 1 testimony per view
 */
function initTestimoniesCarousel() {
  let $testimoniesCarousel = jQuery(".carousel-testimonies");

  let $nextBtn = $testimoniesCarousel.find(".swiper-button-next");
  let $prevBtn = $testimoniesCarousel.find(".swiper-button-prev");

  let swiperTestimonies = new Swiper(".carousel-testimonies", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,
    navigation: {
      nextEl: $nextBtn[0],
      prevEl: $prevBtn[0],
    },
  });
}

/**
 * Initialize the outfitters listing swiper
 * Display 1 outfitter box per view
 */
function initListingOutfittersSwiper() {
  // Disable the carousel on screens wider than 1024px
  if (window.innerWidth > 1024) {
    return false;
  }

  let $listingOutfitters = jQuery(".listing-outfitters");

  swiperInstances.listingOutfitters = new Swiper(".listing-outfitters", {
    grabCursor: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1,
    autoHeight: false,
    spaceBetween: 25,
    watchSlidesProgress: true,
    loop: false,
    breakpoints: {
      620: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
    },
  });
}

/**
 * Initialize the packages listing swiper
 * Display 1 package box per view
 */
function initListingPackagesSwiper() {
  if (window.innerWidth > 1024) {
    return false;
  }

  let $listingPackages = jQuery(".listing-packages");

  swiperInstances.listingPackages = new Swiper(".listing-packages", {
    grabCursor: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1,
    spaceBetween: 25,
    loop: false,
    breakpoints: {
      620: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
    },
  });
}

/**
 * Initialize the activities listing swiper
 * Display 1 activity box per view
 */
function initListingActivitiesSwiper() {
  // Disable the carousel on screens wider than 1024px
  if (window.innerWidth > 1024) {
    return false;
  }

  let $listingActivities = jQuery(".listing-activities");

  let swiperListingActivities = new Swiper(".listing-activities", {
    grabCursor: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1,
    autoHeight: false,
    spaceBetween: 25,
    watchSlidesProgress: true,
    loop: true,
    breakpoints: {
      620: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
    },
  });
}


/**
 * Initialize the filters carousel swiper
 * Display 4 filters per view with elevated z-index
 */
function initFiltersSwiper() {
  // Disable the carousel on screens wider than 1024px
  if (window.innerWidth > 640) {
    return false;
  }

  let swiperFilters = new Swiper(".filters-carousel", {
    grabCursor: true,
    slidesPerView: 'auto',
    autoHeight: true,
    spaceBetween: 32,
    watchSlidesProgress: true,
    loop: false,
    freeMode: {
      enabled: true,
      sticky: false,
    },
    centeredSlides: false,
    slidesOffsetAfter: 40,
    speed: 300,
  });
}


